<template>
	<div class="panel_shouyin">
		<div>
			<!-- <div class="titleLine">
				<el-row>
					<el-col :span="6">
						待受理计划
					</el-col>
				</el-row>
			</div> -->
			<el-table class="table" :data="planList" style="width: 100%;padding:0 10px;">
				<el-table-column prop="memberName" label="姓名" width="110">
				</el-table-column>
				<el-table-column prop="memberMobile" label="电话" width="110">
				</el-table-column>
				<!-- <el-table-column prop="petName" label="宠物" width="120">
				</el-table-column> -->
				<!-- <el-table-column prop="title" label="项目" width="200">
				</el-table-column> -->
				<!-- <el-table-column prop="typeName" label="类型" width="120">
				</el-table-column> -->
				<!-- <el-table-column prop="name" label="分级" width="100">
				</el-table-column> -->
				<el-table-column prop="linkId" label="订单">
					<template slot-scope="scope">
						<div @click="toOrderSee(item)" v-for="(item,index) in scope.row.orderList" :key="index">
							<span> {{item.orderType}}单</span>
							<span class="click">{{item.orderNumber}}</span>
							<span v-if="item.isReturn"> (退换货单)</span>
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column label="时间" width="120">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.exprice_time,"YYYY-MM-DD")}}
					</template>
				</el-table-column> -->
				<!-- <el-table-column prop="name" label="医生" width="100">
				</el-table-column> -->
				<el-table-column prop="remark" label="最后服务时间" width="150">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.lastConsumeTime)}}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="最后服务门店" width="100">
					<template slot-scope="scope">
						{{$public.getShopNameById(scope.row.shopId)}}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="是否需要回访" width="110">
					<template slot-scope="scope">
						{{scope.row.isNeedVisit?'是':'否'}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120">
					<template slot-scope="scope">
						<el-button v-if="scope.row.isNeedVisit" type="text" @click="add(scope.row)" size="small">回访</el-button>
						<el-button type="text" @click="ignore(scope.row)" size="small">忽略</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<genjinAdd v-if="drawerAdd_state" :curItem="curItem" @submit="submit_drawerAdd"></genjinAdd>
		<genjinIgnore v-if="drawerIgnore_state" :curItem="curItem" @submit="submit_drawerIgnore"></genjinIgnore>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import genjinAdd from "../drawer/genjinAdd.vue"
	import genjinIgnore from "../drawer/genjinIgnore.vue"
	export default {
		components:{page,genjinAdd,genjinIgnore},
		data(){
			return{
				planList:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// add
				drawerAdd_state:false,
				curItem:{},
				// ignore
				drawerIgnore_state:false,
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getPlanList();
		},
		methods: {
			toOrderSee(item){
				this.$router.push({path:"/dingdan/saleOrderSee?id="+item.orderNumber})
			},
			// 回访
			add(row){
				this.curItem=row;
				this.drawerAdd_state = true;
			},
			submit_drawerAdd(obj){
				this.drawerAdd_state = false;
				if(obj.type==='success'){
					this.page.page=1;
					this.getPlanList();
				}
			},
			// 忽略
			ignore(row){
				this.curItem=row;
				this.drawerIgnore_state = true;
			},
			submit_drawerIgnore(obj){
				this.drawerIgnore_state = false;
				if(obj.type==='success'){
					this.page.page=1;
					this.getPlanList();
				}
			},
			// 改变分页
			changePage(a){
				this.page.page=a;
				this.getPlanList();
			},
			// 获取表格数据
			getPlanList() {
				let loading=this.$loading();
				let params = {
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				this.$http.get('/api/Platform/WaitingTaskList', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.planList = res.data.data;
						this.page.total = res.data.count;
					}
				})
				
				// let loading=this.$loading();
				// let params = {
				// 	"keyword": "",
				// 	"visitStatus": "", 
				// 	"memberId": "",
				// 	"visitUserId": "",
				// 	"beginTime": 0,
				// 	"endTime": 0,
				// 	"returnVisitType": 2,  // 1 crm客户回访  2 待跟进客户回访  3 病例回访  4 订单回访
				// 	"otherParam": "",
				// 	"pageIndex": this.page.page,
				// 	"pageSize": this.page.pageSize,
				// }
				// this.$http.post(process.env.VUE_APP_Url_8020+'/api/returnvisit/list', params).then(res => {
				// 	loading.close()
				// 	if (res.code == 0) {
				// 		this.planList = res.data.data;
				// 		this.page.total = res.data.count;
				// 	}
				// })
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	background-color: #fff;height: 100%;padding:0 0 20px;box-sizing: border-box;overflow: auto;
	// .titleLine{
	// 	width:100%;
	// 	background-color: #fff;
	// 	height: 44px;
	// 	line-height: 30px;
	// 	padding:8px 8px;
	// 	box-sizing: border-box;
	// 	margin-bottom: 4px;
	// }
	
	.click{
		color:$mainColor;cursor: pointer;
	}
}
</style>
